import React from 'react'
import * as Sentry from '@sentry/react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import RopForm from './views/RopForm'
import Rop01 from './views/Rop01'
import ErrorBoundaryPage from './views/ErrorBoundaryPage'
import GlobalStyle from './styles/styledcomponent/globalStyle'
import TermsModal from './components/common/TermsModal'
import Rop02 from './views/Rop02'
import Rop03 from 'src/views/Rop03'
import { captureError } from 'src/service/utils/sentry'
import Layout from 'src/views/Layout'

const App = (): JSX.Element => {
  return (
    <>
      <GlobalStyle />
      <BrowserRouter>
        <Sentry.ErrorBoundary
          fallback={<ErrorBoundaryPage />}
          onError={(error) => {
            if (error instanceof Error) captureError(error)
          }}
        >
          <Routes>
            <Route element={<Layout />}>
              <Route path="/rop01/:pcode/:requestID/:telecom" element={<Rop01 />} />
              <Route path="/rop01/:pcode/:requestID/:authKey/:telecom" element={<Rop01 />} />
              <Route path="/rop02/:pcode/:requestID/:telecom" element={<Rop02 />} />
              <Route path="/rop02/:pcode/:requestID/:authKey/:telecom" element={<Rop02 />} />
              <Route path="/rop03/:pcode/:requestID/:telecom" element={<Rop03 />} />
              <Route path="/rop03/:pcode/:requestID/:authKey/:telecom" element={<Rop03 />} />
              <Route path="/ropForm/:pcode/:requestID/:telecom" element={<RopForm />} />
              <Route path="/ropForm/:pcode/:requestID/:authKey/:telecom" element={<RopForm />} />
              <Route
                path="/terms/:requestID/:telecom/:termsIDX/:termsOrderIdx"
                element={<TermsModal />}
              />
              <Route path="*" element={<ErrorBoundaryPage />} />
            </Route>
          </Routes>
        </Sentry.ErrorBoundary>
      </BrowserRouter>
    </>
  )
}

export default App
